import { Component } from '@angular/core';
import { IdentityService } from '../../../api/services';
import { UserItem } from '../../../api/models';
import { slugify } from '../../utils/utils';
import { Router } from '@angular/router';
import { enumUserRole } from '../../utils/enum-user-role';
import { AuthService } from '../../../guards/services/auth.service';
import { ModalLoginComponent } from '../../../modal-login/modal-login.component';
import { DialogService } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-leader-carousel',
  templateUrl: './leader-carousel.component.html',
  styleUrl: './leader-carousel.component.scss',
})
export class LeaderCarouselComponent {
  responsiveOptions: any[] | undefined;
  leaders: UserItem[] = [];
  enumUserRole = enumUserRole;

  constructor(
    private identityService: IdentityService,
    private router: Router,
    public auth: AuthService,
    private dialogService: DialogService,
  ) {}

  ngOnInit() {
    this.responsiveOptions = [
      {
        breakpoint: '1399px',
        numVisible: 3,
        numScroll: 1,
      },
      {
        breakpoint: '1199px',
        numVisible: 3,
        numScroll: 1,
      },
      {
        breakpoint: '991px',
        numVisible: 2,
        numScroll: 1,
      },
      {
        breakpoint: '767px',
        numVisible: 1,
        numScroll: 1,
      },
    ];
    this.getLeaders();
  }

  gotoTourLeaders() {
    if (!this.auth.isLogged()) {
      sessionStorage.setItem('book_item_redirect', '/tour-leader/leaders-list');
      this.dialogService.open(ModalLoginComponent, {
        showHeader: false,
        width: '30vw',
        modal: true,
        breakpoints: {
          '960px': '40vw',
          '640px': '90vw',
        },
        styleClass: 'transparent-dialog',
        draggable: false,
        transitionOptions: '400ms cubic-bezier(0.34, 1.56, 0.64, 1)',
      });
    } else {
      this.router.navigateByUrl('/tour-leader/leaders-list');
    }
  }

  getLeaders() {
    this.identityService
      .identityControllerGetAllTourLeaders({
        limit: 7,
        skip: 0,
      })
      .subscribe({
        next: (res) => {
          this.leaders = res.data.list;
        },
      });
  }

  goTo(g: UserItem) {
    if (g.related_registry) {
      const business_profile_url = slugify(g.related_registry?.name);
      this.router.navigate(['/business', business_profile_url]);
    } else {
      this.router.navigate(['/user/profile', g.username]);
    }
  }
}
